/* eslint-disable */
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import * as Yup from 'yup';
import { useNavigate, useParams } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Container, Stack, TextField, InputAdornment, IconButton } from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import Divider from '@material-ui/core/Divider';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Page from '../../../Page';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import { AESEncryptionParam, AESDecryptionParam } from '../../../../helpers/AesEncrypt';
import services from '../Service';
import Button from '@material-ui/core/Button';
import { ToastContainer, toast } from 'react-toastify';
import MenuItem from '@material-ui/core/MenuItem';
import Card from '@material-ui/core/Card';
import TableContainer from '@mui/material/TableContainer';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { CustomMaterialTable } from '../../Common/CustomMaterialTable';
import SearchNotFound from '../../../SearchNotFound';

var screenCode = 'RETURNQUANTITESREASSIGN';

export default function ReturnQuantitesReAssign(props) {
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });
    const [groupList, setGroupList] = useState([]);
    const [ReturnOrder, setReturnOrder] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [ReturnOrderSend, setReturnOrderSend] = useState([]);

    const headCells = [
        {
            id: 'collectionCenter',
            numeric: false,
            headCellAlign: 2,
            tableCellAlign: 2,
            disablePadding: false,
            label: 'Collection Center'
        },
        {
            id: 'productCode',
            numeric: false,
            headCellAlign: 2,
            tableCellAlign: 2,
            disablePadding: false,
            label: 'SKU'
        },
        {
            id: 'productName',
            numeric: false,
            headCellAlign: 2,
            tableCellAlign: 2,
            disablePadding: false,
            label: 'Crop'
        },
        {
            id: 'returnQuantity',
            numeric: true,
            headCellAlign: 3,
            tableCellAlign: 3,
            disablePadding: false,
            label: 'Return Qty'
        },
        {
            id: 'reOrderStatus',
            numeric: false,
            headCellAlign: 1,
            tableCellAlign: 1,
            disablePadding: false,
            label: 'Status'
        },
    ];

    const tableData = [
        {
            id: 'collectionCenter',
            numeric: false,
            headCellAlign: 1,
            tableCellAlign: 'left',
            disablePadding: false,
            label: 'Collection Center'
        },
    ];


    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: true,
        submitButtonName: 'Re Allocate',
        pageheadername: 'Return Quantities Re-Allocate'
    });
    const [isTable, setIsTable] = useState(true);
    const [date, setDate] = useState(new Date());

    const [formData, setFormData] = useState({
        groupID: '1',
        operationEntityID: '1',
        productID: '0',
        dataID: '0'
    });

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        setReturnOrder([]);
    }, [date]);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find((p) => p.permissionCode == 'VIEWRETURNQUANTITESREASSGN');

        if (isAuthorized === undefined) {
            navigate('/404');
        }

        var isGroupFilterEnabled = permissions.find((p) => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find((p) => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
        });
        trackPromise(GetAllGroups());
    }

    async function GetAllGroups() {
        var res = await services.GetAllGroupsForDropDown();
        if (res != null) {
            setGroupList(res);
        }
    }

    async function SearchData() {
        setReturnOrder([]);
        let model = {
            groupID: formik.values.groupID,
            date: new Date(date).toISOString()
        };
        const Result = await services.GetReturnQuantitiesDetails(model);
        if (Result != null) {
            setReturnOrder(Result);
        }
    }

    function generateGroupForDropDownMenu(data) {
        let items = [];
        if (data != null) {
            data.forEach((x) => {
                items.push(
                    <MenuItem key={x.groupID} value={x.groupID}>
                        {x.groupName}
                    </MenuItem>
                );
            });
        }
        return items;
    }

    const returnQuantitesSearchSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group required'),
        operationEntityID: Yup.number().min(1, 'Please Select Operation Entity').required('Operation Entity required'),
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            dateID: formData.dataID
        },

        validationSchema: returnQuantitesSearchSchema,
        onSubmit: (values) => {
            if (pageProps.isEdit > 0) {
                setIsTable(true);
            } else {

            }
        }
    });
    async function GenerateReturnOrder() {
        setIsLoading(true);
        let ReturnOrderDetails = await services.GetReturnQuantitiesSumDetails(date.toISOString());

        const newDate = new Date(date);
        newDate.setDate(newDate.getDate() - 1);

        var gpap = await services.GetApprovedProductPriceByDateForReOrder(newDate.toISOString());
        let productPrice = _.cloneDeep(gpap);

        var productPriceResult = approvedProductPriceSort(productPrice);
        let model = {
            date: newDate.toISOString(),
            productPrice: productPriceResult,
            outletOrder: [],
            newOutletOrder: ReturnOrderDetails
        };
        var res = await services.SaveGenerateOrder(model);
        if (res.statusCode === "Success") {
            toast.success(res.message);
        } else {
            toast.error(res.message);
        }
        setTimeout(() => {
            setIsLoading(false);
        }, 3000);
    }

    function orderAndSumBy(arr, orderBy, orderBySecondary, sumBy) {
        return arr
            .map(item => {
                item.total = arr.filter(i => i[orderBy] === item[orderBy]).reduce((acc, o) => acc + o[sumBy], 0);
                item.percentage = parseFloat(item.quantity / item.total);
                item.createdBy = parseInt(TokenDecoder.getUserIDFromToken());
                item.orderDate = date.toISOString();
                item.margeModel = [];
                return item;
            })
            .sort((a, b) => {
                if (a[orderBy] === b[orderBy]) {
                    return a[orderBySecondary] + b[orderBySecondary];
                }
                return a[orderBy] - b[orderBy];
            });
    }

    function approvedProductPriceSort(DataList) {
        let finalArray = []
        for (const defaultElement of DataList) {
            const dd = orderAndSumBy(defaultElement.priceModel, 'realizedPrice', 'quantity', 'quantity')

            let finalModel = {
                productCode: defaultElement.productCode,
                productName: defaultElement.productName,
                isGap: defaultElement.isGap,
                childProductCode: defaultElement.childProductCode,
                priceModel: dd
            }
            finalArray.push(finalModel)
        }
        return finalArray;
    }

    function formatDateAsInt(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return parseInt(`${year}${month}${day}`, 10);
    }

    const currentDate = formatDateAsInt(new Date());
    const PickerDate = formatDateAsInt(new Date(date));
    const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    return (
        <Page title="Return Quantities Re-Allocate | Agri-Connect">
            <Container>
                <CommonPageHeader path="/dashboard" btname="Back" pageName={pageProps.pageheadername} leftButtonHidden={true} />
                <FormikProvider value={formik}>
                    <ToastContainer position="bottom-right" pauseOnHover />
                    <Form
                        autoComplete="off"
                        disabled={!(formik.isValid && formik.dirty)}
                        noValidate
                        onSubmit={handleSubmit}
                    >
                        <Stack spacing={2}>
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                <TextField
                                    select
                                    fullWidth
                                    size="small"
                                    label="Group *"
                                    value={formik.values.groupID}
                                    onChange={formik.handleChange}
                                    {...getFieldProps('groupID')}
                                    error={Boolean(touched.groupID && errors.groupID)}
                                    helperText={touched.groupID && errors.groupID}
                                    InputProps={{
                                        readOnly: !permissionList.isGroupFilterEnabled
                                    }}
                                >
                                    <MenuItem key={0} value={0}>
                                        {' '}
                                        Select Group
                                    </MenuItem>
                                    {generateGroupForDropDownMenu(groupList)}
                                </TextField>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DatePicker
                                        label="Select Date"
                                        value={date}
                                        onChange={(newValue) => {
                                            setDate(newValue);
                                        }}

                                        renderInput={(params) => <TextField
                                            fullWidth
                                            size="small"
                                            {...getFieldProps('date')}
                                            error={Boolean(touched.date && errors.date)}
                                            helperText={touched.date && errors.date}

                                            {...params} />}
                                    />
                                </LocalizationProvider>
                                <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                    <Button type="submit" color="secondary" variant="outlined" onClick={() => SearchData()}>
                                        Search
                                    </Button>
                                </Stack>
                            </Stack>
                            <br />
                            <Divider variant="middle" />
                            <br />
                            {ReturnOrder.length != 0 ? (
                                <>
                                    <Card>
                                        <TableContainer>
                                            <CustomMaterialTable
                                                headCells={headCells}
                                                tableData={ReturnOrder}
                                            />
                                        </TableContainer>
                                    </Card>
                                    <Divider variant="middle" />
                                    {PickerDate >= currentDate ?
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                            <LoadingButton size="small" type='button' onClick={() => GenerateReturnOrder()}
                                                color="secondary" variant="outlined" loading={isLoading}>
                                                {pageProps.submitButtonName}
                                            </LoadingButton>
                                        </Stack> : null}
                                </>
                            ) : <SearchNotFound searchQuery="Return Quantities Re-Allocate" />}
                        </Stack>
                    </Form>
                </FormikProvider>
            </Container>
        </Page>
    );
}

